import React from 'react';
import './ItemDetailComponent.css';
import { useLocation } from 'react-router-dom';

function ItemDetailComponent() {

  const location = useLocation();
  const state = location.state;

  const data = state ? state.data : null;

  console.log(state)

  const item = {
    id: 1,
    title: 'LOREAL PARIS',
    img: require('../assets/cosmetic_1.jpg'),
    description: 'Extraordinary Oil - Gold',
    price: 250000,
  };

  const brand = {
    id: 1,
    title: 'LOREAL PARIS',
    img: require('../assets/loreal-paris-logo.png'),
    description: 'Extraordinary Oil - Gold',
    price: 250000,
  };

  // Access the values from the parsedRowData object

  return (
    <div className="item-container">
      <div className="item-images">
        <img src={data.img} alt="Product" className="item-image" />
        <img src={brand.img} alt="Product" className="brand-image" />
      </div>
      <div className="item-details">
        <h2 className="item-name">{data.title}</h2>
        <p className="item-description">{item.description}</p>
        <p className="item-price">Price: Rp. {data.price.toLocaleString("id-ID")}</p>
        <p>How to use</p>
          <div className="user-guide-container">
            <p className="item-description-long">
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
            </p>
          </div>
      </div>
    </div>
  );
}

export default ItemDetailComponent;